import { render, staticRenderFns } from "./ModalInviteUserAndSetRole.vue?vue&type=template&id=3898c7ee&scoped=true"
import script from "./ModalInviteUserAndSetRole.vue?vue&type=script&lang=js"
export * from "./ModalInviteUserAndSetRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3898c7ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3898c7ee')) {
      api.createRecord('3898c7ee', component.options)
    } else {
      api.reload('3898c7ee', component.options)
    }
    module.hot.accept("./ModalInviteUserAndSetRole.vue?vue&type=template&id=3898c7ee&scoped=true", function () {
      api.rerender('3898c7ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/ModalInviteUserAndSetRole.vue"
export default component.exports